import { REPORT_REQUEST, REPORT_SUCCESS, REPORT_FAILURE, REPORT_CLEAR } from '../constants'

const initialState = {
  loaded: false,
  loading: false,
  content: null
}

export function report(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case REPORT_REQUEST:
      return { ...state, loaded: false, loading: true }
    case REPORT_SUCCESS:
      return { ...state, content: payload.content, loaded: true, loading: false }

    case REPORT_FAILURE:
    case REPORT_CLEAR:
      return { ...state, content: null, loaded: false, loading: false }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/report.js